import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import TodoForm from "./_form"

interface Option {
  id: number
  name: string
}
interface Todo {
  id: number
  title: string
  [key: string]: unknown
}
interface Props {
  todo: Todo
  users: Option[]
  notifiable_users?: Option[]
  errors?: Record<string, string[]>
}

export default function Edit({ todo, users, notifiable_users, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Todos", href: "/marketing_todos" },
    { title: todo.title, href: `/marketing_todos/${todo.id}` },
    { title: "Edit", href: `/marketing_todos/${todo.id}/edit` },
  ]
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit ${todo.title}`} />
      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Edit Marketing Todo</h1>
        <TodoForm
          todo={todo}
          users={users}
          notifiableUsers={notifiable_users}
          errors={errors}
          isEdit
        />
      </div>
    </AppLayout>
  )
}
